import type { FormValue } from '../../types';
import type { SumTermEntry } from './types';

/** True when the current answer selects the scoring option (`value`). */
export function answerMatchesScoreValue(
  answer: FormValue | undefined,
  value: string
): boolean {
  if (answer === undefined || answer === null) return false;
  if (Array.isArray(answer)) return answer.includes(value);
  if (typeof answer === 'string') return answer === value;
  return false;
}

export function sumComputedScores(
  answers: Record<string, FormValue>,
  terms: SumTermEntry[]
): number {
  let total = 0;
  for (const row of terms) {
    if (row.countWhen != null) {
      if (answers[row.countWhen.qid] !== row.countWhen.eq) continue;
    }
    if (answerMatchesScoreValue(answers[row.qid], row.value)) {
      total += row.points;
    }
  }
  return total;
}
